
// 插件路由
const dada = () => import(/* webpackChunkName: "dada" */ '~/addon/dada/pages/dada.vue')

const routes = [
	{
        path: '/dada',
        component: dada
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/dada/router/index.js